module.exports = __webpack_public_path__ + "img/career-discovery.b54d5ec3.jpg";